module.exports = __webpack_public_path__ + "static/media/bg-kid-babies.efb570ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/component/modalConductor/topCategoriesModal/images/bg-kid-babies.jpg
// module id = 2133
// module chunks = 0